// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__lXlE9","label":"Section_label__2Qo3k","contentWrap":"Section_contentWrap__185x-","footer":"Section_footer__169QW","footerInner":"Section_footerInner__1lgN_"};